/** The dashboard Tasks panel's tabs. */
export type TasksPanelTab = 'today' | 'upcoming' | 'unscheduled'

const TABS: readonly TasksPanelTab[] = ['today', 'upcoming', 'unscheduled']

/**
 * A `tab` / `dashboardTab` search param as a Tasks panel tab. Links saved before the panel's
 * Backlog tab was split, and its Projects tab removed, still land somewhere sensible: Backlog on
 * Upcoming, Projects on Today. Anything else is no tab.
 */
export function parseTasksPanelTab(value: unknown): TasksPanelTab | undefined {
  if (value === 'backlog') return 'upcoming'
  if (value === 'projects') return 'today'
  return TABS.includes(value as TasksPanelTab) ? (value as TasksPanelTab) : undefined
}
